module.exports = __webpack_public_path__ + "img/attendee.773d485e.png";